export enum RestrictedAccountStatus {
  Requested = 0,
  InReview,
  Approved,
  Rejected,
  Paper,
  Inactive,
}
